/* eslint-disable react/prop-types */
import React from 'react';
import { PageSizeSelector } from "./PageSizeSelector";
import { RowRangeDisplay } from "./RowRangeDisplay";
import { PageNavigation } from "./PageNavigation";
import { PaginationRow } from "./styles";
export function GridPagination(props) {
  var pageSize = props.pageSize,
    rowCount = props.rowCount,
    currentPage = props.currentPage,
    lastPage = props.lastPage,
    setPageSize = props.setPageSize,
    goToPage = props.goToPage,
    pageSizeOptions = props.pageSizeOptions,
    hidePageNavigationGroup = props.hidePageNavigationGroup,
    hideSkipButtons = props.hideSkipButtons,
    hidePageSizeSelector = props.hidePageSizeSelector;
  return /*#__PURE__*/React.createElement(PaginationRow, {
    className: "grid-pagination-wrapper"
  }, pageSizeOptions !== null && !hidePageSizeSelector && /*#__PURE__*/React.createElement(PageSizeSelector, {
    pageSize: pageSize,
    goToPage: goToPage,
    setPageSize: setPageSize,
    pageSizeOptions: pageSizeOptions
  }), /*#__PURE__*/React.createElement(PageNavigation, {
    currentPage: currentPage,
    lastPage: lastPage,
    goToPage: goToPage,
    hidePageNavigationGroup: hidePageNavigationGroup,
    hideSkipButtons: hideSkipButtons
  }), /*#__PURE__*/React.createElement(RowRangeDisplay, {
    pageSize: pageSize,
    rowCount: rowCount,
    currentPage: currentPage
  }));
}
export default GridPagination;